<template>
    <CHeader fixed with-subheader 
        style="background-color:#cc9933;">
        <CHeaderNav class="d-md-down-none mr-auto">
            <CHeaderNavItem class="px-3">
                <CHeaderNavLink to="/charges" exact>
                    {{$t('charges.title').toUpperCase()}}
                </CHeaderNavLink>
            </CHeaderNavItem>
            <CHeaderNavItem class="px-3">
                <CHeaderNavLink to="/empresas" exact>
                    {{$t('empresas.title').toUpperCase()}}
                </CHeaderNavLink>
            </CHeaderNavItem>
            <CHeaderNavItem class="px-3">
                <CHeaderNavLink to="/vehicles" exact>
                    {{$t('vehicles.title').toUpperCase()}}
                </CHeaderNavLink>
            </CHeaderNavItem>
            <CHeaderNavItem class="px-3">
                <CHeaderNavLink @click.native="onShowDetail" to="#" exact>
                    {{$t('grupo_wp.title').toUpperCase()}}
                </CHeaderNavLink>
            </CHeaderNavItem>
            <CHeaderNavItem class="px-3">
                <CHeaderNavLink to="/directories" exact>
                    {{$t('directories.title').toUpperCase()}}
                </CHeaderNavLink>
            </CHeaderNavItem>
            <CHeaderNavItem class="px-3">
                <CHeaderNavLink to="/providers" exact>
                    {{$t('providers.title').toUpperCase()}}
                </CHeaderNavLink>
            </CHeaderNavItem>
            <CHeaderNavItem class="px-3">
                <CHeaderNavLink to="/terms" exact>
                    {{$t('terms.title').toUpperCase()}}
                </CHeaderNavLink>
            </CHeaderNavItem>
            <CHeaderNavItem class="px-3" v-if="!isAuth">
                <CHeaderNavLink to="/login" exact>
                    {{$t('login.label').toUpperCase()}}
                </CHeaderNavLink>
            </CHeaderNavItem>
            <CHeaderNavItem class="px-3"  v-if="!isAuth">
                <CHeaderNavLink to="/register" exact>
                    {{$t('login.register').toUpperCase()}}
                </CHeaderNavLink>
            </CHeaderNavItem>
        </CHeaderNav>
        <CHeaderNav class="mr-2">
            <TheHeaderDropdownAccnt/>
        </CHeaderNav>
        <CSubheader class="px-3">
            <CBreadcrumbRouter class="border-0 mb-0"/>
        </CSubheader>
        <CModal
            color="warning"
            :show.sync="showDetail"
            :title="$t('charges.detail')"
        >
            <div v-if='!isAuth'>
                {{messageLogin}}
            </div>
            <div v-else>
                <CRow>
                    <div class="col-sm-12">
                        {{messagePremium}}
                    </div>
                </CRow>
                <CRow>
                    <div class="col-sm-6 offset-sm-3 mt-5">
                        <a :href="urlWhatsappPremium" class="btn-whatsapp" target="_blank">
                            <CIcon :content="iconChat" size="3xl"/> {{ $t('button.whatsapp') }} 
                        </a>
                    </div>
                </CRow>
            </div>
        </CModal>
    </CHeader>
</template>

<script>
import store from '../store'
import { cilChatBubble } from '@coreui/icons';
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'

export default {
    name: 'TheHeader',
    components: {
        TheHeaderDropdownAccnt,
    },
    data() {
        return {
            showDetail: false,
            iconChat: cilChatBubble,
        }
    },
    computed: {
        isAuth() {
            return localStorage.getItem('login') === 'true';
        },
        urlWhatsappPremium() {
            if (store.state.configuration != null 
                && store.state.configuration.configuration != null) {
                return "https://wa.me/"+store.state.configuration.configuration.text_not_show_premium_trip_phone;
            } else {
                return "";
            }
        },
        messageLogin() {
            //return "Debes Registrarte primero, te lleva 1 minuto";
            if (store.state.configuration != null 
                && store.state.configuration.configuration != null) {
                return store.state.configuration.configuration.registrate;
            } else {
                return "";
            }
        },
        messagePremium() {
            //return "Debes Registrarte primero, te lleva 1 minuto";
            if (store.state.configuration != null) {
                return store.state.configuration.configuration.text_not_show_premium_trip;
            } else {
                return "aoeu";
            }
        },
    },
    methods: {
        onShowDetail() {
            console.log("aoeuaoeu");
            this.showDetail = true;
        }
    }
}
</script>

<style>
.c-header .c-header-nav .c-header-nav-link, .c-header .c-header-nav .c-header-nav-btn {
    font-weight: bold;
    color: white !important; 
}

.c-header .c-subheader {
    font-weight: bold;
    color: white !important; 
    background-color: #cc9933;
}

.breadcrumb-item .active {
    font-weight: bold;
    color: white !important; 
}    

.active {
    font-size: 20px !important;
    color: white !important;
    font-weight: bold !important;
}

</style>
